import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-data3",
  "use": "icon-data3-usage",
  "viewBox": "0 0 256 256",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 256 256\" id=\"icon-data3\">\r\n  <polygon points=\"177 16 197 37 134.499 99 206 99 206 127 144 127 144 167 206 167 206 192 144 192 144 240 115 240 115 192 51 192 51 167 115 167 115 127 51 127 51 99 121.821 99 60 37 81 16 128 64\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol